import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {exhibitionScenarioActions} from "../../../../actions/exhibition-scenario.actions";
import {connect} from "react-redux";
import {userHelper} from "../../../../helpers/user-helper";

class NetworkDeviceContentCopyForm extends Component {

    state = {
        form: {
            exhibitionScenarioId: null,
        }
    }

    componentDidMount() {
        const { dispatch, content, user } = this.props;

        if(userHelper.getUseExhibitionScenario(user)) {
            dispatch(exhibitionScenarioActions.getDropdownListExhibitionScenario());
            this.setState({
                form: {
                    ...this.state.form,
                    exhibitionScenarioId: content.exhibitionScenarioId
                }
            })
        }
    }

    componentWillUnmount() {
        this.setState({
            form: {
                exhibitionScenarioId: null
            }
        })
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.submit({
            ...this.props.content,
            exhibitionScenarioId: this.state.form.exhibitionScenarioId
        });
    }

    handleSelectSimple = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value === "null" ? null : e.target.value
            }
        })
    }

    handleCloseModal = (e) => {
        e.preventDefault();
        this.props.closeModal();
    }

    render() {
        const {t, content, exhibitionScenarioDropdown, user } = this.props;

        const selectExhibitionScenario = exhibitionScenarioDropdown?.length > 0 ?
            (exhibitionScenarioDropdown.map((scenario, idx) => (<option key={idx} value={scenario.id}> {scenario.label} </option>))) :
            (<option value={null}>Loading ...</option>);

        return (
            <React.Fragment>
                <h6><b>{t('label')}:</b> { content.label }</h6>
                <form onSubmit={this.onSubmit}>
                    { userHelper.getUseExhibitionScenario(user) ? (
                        <div className="form-group">
                            <label htmlFor="exhibitionScenario" className="col-form-label"> {t('exhibition-scenario')} </label>
                            <select className="form-control" name="exhibitionScenarioId"
                                    value={this.state.form.exhibitionScenarioId || ""}
                                    onChange={this.handleSelectSimple}>
                                <option value="null">{t('exhibition-scenario-default')}</option>
                                {!selectExhibitionScenario || selectExhibitionScenario}
                            </select>
                        </div>
                    ) : (
                        <React.Fragment/>
                    ) }
                    <div className="alert alert-warning">
                        {t('are-you-sure-make-copy')}
                    </div>
                    <div className="form-group float-right">
                        <button type="submit" className={"btn btn-primary mx-1" }>
                            <i className="fas fa-check"> </i> {t('yes')}
                        </button>
                        <button type="button" className={"btn btn-secondary mx-1"} onClick={this.handleCloseModal}>
                            <i className="fas fa-times"> </i> {t('no')}
                        </button>
                    </div>
                </form>

            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    const { exhibitionScenarioDropdown } = state.exhibitionScenarioReducer;
    return {
        exhibitionScenarioDropdown,
        user
    }
}
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceContentCopyForm))